(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('EstadiosFenologicosCtrl', EstadiosFenologicosController);

  // eslint-disable-next-line max-params, max-lines-per-function
  function EstadiosFenologicosController($scope, $q, LoadingService,
    EstadiosFenologicosService, AtividadesService,
    MessagesService, $location,
    Flash, $routeParams, $route) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.atividades = [];
    vm.estadios = [];
    vm.loading = false;
    vm.createNew = false;
    vm.pages = {};
    vm.filters = {
      descricao: '',
      atividade: vm.atividades[0]
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.openEdit = openEdit;
    vm.filterItems = filterItems;
    vm.deleteItem = deleteItem;

    //////////////////////////////////////////
    // Function declarations

    function listEstadios() {
      vm.createNew = false;
      vm.loading = true;
      vm.filters = {
        descricao: $routeParams.descricao || '',
        atividade: ($routeParams.atividade && _.find(vm.atividades, { id: +$routeParams.atividade })) ||
        vm.atividades[0]
      };
      return $q.all([
        EstadiosFenologicosService.loadProducts(vm.filters)
      ])
        .then(([estadios]) => {
          vm.estadios = estadios;
          vm.loading = false;
        })
        .catch((error) => {
          console.error('Erro carregando dados', error);
          MessagesService.alert('Erro carregando dados, tente novamente.');
          vm.loading = false;
        });
    }

    function openEdit(index) {
      vm.estadios.find((estadio) => estadio.id === index).edit = true;
    }

    function filterItems() {
      $route.updateParams({
        descricao: vm.filters.descricao,
        atividade: (vm.filters.atividade || {}).id
      });
    }

    function deleteItem(estadio) {
      vm.loading = true;
      return MessagesService.confirm(`Você tem certeza que deseja apagar o item ${estadio.descricao}?`)
        .then(() => EstadiosFenologicosService.deleteItem(estadio.id))
        .then(() => {
          MessagesService.alert('Item apagado com sucesso!');
          $scope.$emit('estadioCreated');
        });
    }

    LoadingService.showLoading();

    vm.loading = true;

    $scope.$root.initialize
      .then(() => {
        if ($scope.$root.parametros.nao_cliente_agrogestao && $scope.$root.permissions.estadios_fenologicos.canRead) {
          AtividadesService.listComEmpreendimento().then(function(atividades) {
            vm.atividades = atividades.data || [];
            return listEstadios();
          });
        } else {
          $location.path('/');
          Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        }
      })
      .catch(() => $scope.$root.errorRootInitialize())
      .finally(() => LoadingService.hideLoading());

    // Eventos do editor
    $scope.$on('cancelCreate', () => vm.createNew = false);
    $scope.$on('cancelEdit', (event, estadio) => estadio.edit = false);
    $scope.$on('estadioUpdated', (event, estadio, result) => {
      vm.estadios[vm.estadios.indexOf(estadio)] = result;
    });
    $scope.$on('estadioCreated', () => listEstadios());

    // Eventos da rota
    $scope.$on('$routeUpdate', () => listEstadios());
  }
}());

